import { render, staticRenderFns } from "./left.vue?vue&type=template&id=01dda5be&scoped=true"
import script from "./left.vue?vue&type=script&lang=js"
export * from "./left.vue?vue&type=script&lang=js"
import style0 from "./left.vue?vue&type=style&index=0&id=01dda5be&prod&lang=css"
import style1 from "./left.vue?vue&type=style&index=1&id=01dda5be&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dda5be",
  null
  
)

export default component.exports